import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GroundTruthFilePage } from '@/features/GroundTruthHub/GroundTruthFilePage';
import { ingestedFileIdParams } from '@/features/GroundTruthHub/routeParams';
import { groundTruthRouteBoundaries } from '@/features/GroundTruthHub/GroundTruthNotFound';

const searchSchema = z.object({
    tab: z.string().optional(),
});

function FilePageRoute() {
    const { ingestedFileId } = Route.useParams();
    return <GroundTruthFilePage ingestedFileId={ingestedFileId} />;
}

export const Route = createFileRoute('/ground-truth/$ingestedFileId/')({
    ...groundTruthRouteBoundaries,
    component: FilePageRoute,
    params: ingestedFileIdParams,
    validateSearch: searchSchema,
});
